"use client"
import React from 'react';
import dynamic from 'next/dynamic';
import Hero from '@/components/hero';
import FeaturedProducts from '@/components/featuredProducts';
import TodaysSpecials from '@/components/todaysSpecials';

// Import InstagramGallery with more explicit configuration
const InstagramGallery = dynamic(
  () => import('@/components/instagram-gallery').then(mod => {
    return mod.default;
  }),
  {
    ssr: true,
    loading: () => {
      return (
        <div className="min-h-[600px] flex items-center justify-center bg-[#FFF6F0]">
          <div className="animate-pulse flex flex-col items-center">
            <div className="w-12 h-12 bg-primary-orange/20 rounded-full mb-4"></div>
            <p className="text-neutral-600">Loading Instagram feed...</p>
          </div>
        </div>
      );
    }
  }
);

const Testimonials = dynamic(() => import('@/components/testimonials.js'), {ssr: true});
const Contact = dynamic(() => import('@/components/contact'), {ssr: true});

export default function MochiWebsite() {
  return (
    <div className="min-h-screen">
      <main className="relative">
        <Hero />
        <FeaturedProducts noPaddingTop />
        <TodaysSpecials noPaddingTop />
        <InstagramGallery noPaddingTop />
        <Testimonials noPaddingTop />
        <Contact noPaddingTop />
      </main>
    </div>
  );
}
